import React from 'react';

import { Stack } from '@backyard-ui/core';

import { MoreOptionsDrawer } from './MoreOptionsDrawer';
import { Options } from './Options';

type SellersProps = {
  itemId: number;
};

function Sellers(props: Readonly<SellersProps>) {
  const { itemId } = props;

  return (
    <Stack spacing="2" direction="column" className="w-full">
      <Options itemId={itemId} />
      <MoreOptionsDrawer itemId={itemId} />
    </Stack>
  );
}

export default Sellers;
